import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import {
    badRequestError,
    invalidApiDataError,
} from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { insightsMapper } from "../../mappers/insights/insightsMapper"
import { INSIGHTS_EMBEDDED_URL } from "../../urls/private"

interface IQuickSightEmbeddedUrl {
    url: string | undefined
    error: AppError | null
    isLoading: boolean
}

/**
 * Hook for getting the QuickSight embedded URL
 * @returns {IQuickSightEmbeddedUrl} - SWR data, loading and error states.
 */
const useGetQuickSightEmbeddedUrl = (): IQuickSightEmbeddedUrl => {
    const { data, error, isLoading } = useSWR(
        INSIGHTS_EMBEDDED_URL,
        async (url: string): Promise<string> => {
            try {
                const res = await getClientProtected(url)

                return insightsMapper.mapEmbeddedUrl(res).body
            } catch (err) {
                badRequestError("Failed to retrieve QuickSight embedded URL")
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    )
    return {
        url: data,
        error,
        isLoading,
    }
}

export default useGetQuickSightEmbeddedUrl
